module.exports = __webpack_public_path__ + "img/avatar.e90116fd.png";